import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { useDrop } from "react-dnd";
import { CanvasContext } from "../../../contexts/CanvasContext";
import ButtonComponent from "./ButtonComponent";
import ImageComponent from "./ImageComponent";
import HeaderComponent from "./HeaderComponent";
import ParagraphComponent from "./ParagraphComponent";
import IconComponent from "./IconComponent";
import LinkComponent from "./LinkComponent";
import CheckboxComponent from "./CheckboxComponent";
import RadioComponent from "./RadioComponent";
import ListComponent from "./ListComponent";
import TableComponent from "./TableComponent";
import VideoComponent from "./VideoComponent";
import TextInputComponent from "./TextComponent";
import RangeComponent from "./RangeComponent";
import PasswordInputComponent from "./PasswordInputComponent";
import EmailInputComponent from "./EmailInputComponent";
import NumberInputComponent from "./NumberInputComponent";
import DateInputComponent from "./DateInputComponent";
import ColorInputComponent from "./ColorInputComponent";
import FileInputComponent from "./FileInputComponent";
import AudioComponent from "./AudioComponent";
import DropDownComponent from "./DropDownComponent";
import MapComponent from "./MapComponent";
import Division from "./Division";
import Nav from "./Nav";
import HeaderTag from "./HeaderTag";
import Hgroup from "./Hgroup";
import Footer from "./Footer";
import FormComponent from "./FormComponent";
import MainComponent from "./MainComponent";
import ArticleComponent from "./ArticleComponent";
import AsideComponent from "./AsideComponent";
import HRTag from "./HRTag";
import BRTag from "./BRTag";
import OutputComponent from "./OutputComponent";
import IframeComponent from "./IframeComponent";
import Section  from "./Section";

const Span = ({ span }) => {
  const spanRef = useRef(null);

  const { addElement, hoveredDivision, files, addCanvasDrop, addDivision } =
    useContext(CanvasContext);
  const isHovered = span.id === hoveredDivision;
  const [isSpanHovered, setIsSpanHovered] = useState(false);
  const [isSpanFocused, setIsSpanFocused] = useState(false);
  const [isSpanActive, setIsSpanActive] = useState(false);
  const [backgroundImageUrl, setBackgroundImageUrl] = useState(null);

  const [, drop] = useDrop({
    accept: [
      "DroppableDiv",
      "DroppableButton",
      "DroppableImage",
      "DroppableHeading",
      "DroppableParagraph",
      "DroppableIcon",
      "DroppableLink",
      "DroppableCheckbox",
      "DroppableRadio",
      "DroppableList",
      "DroppableTable",
      "DroppableVideo",
      "DroppableAudio",
      "DroppableTextInput",
      "DroppableRangeInput",
      "DroppablePasswordInput",
      "DroppableEmailInput",
      "DroppableNumberInput",
      "DroppableDateInput",
      "DroppableColorInput",
      "DroppableFileInput",
      "DroppableDropDown",
      "DroppableMap",
      "DroppableNav",
      "DroppableHeader",
      "DroppableHGroup",
      "DroppableFooter",
      "DroppableSection",
      "DroppableSpan",
      "DroppableForm",
      "DroppableMain",
      "DroppableArticle",
      "DroppableAside",
      "DroppableHorizontalRule",
      "DroppableLineBreak",
      "DroppableIframe",

    ],
    drop: (item, monitor) => {
      if (!monitor.didDrop()) {
        if (item.type === "DroppableDiv") {
          addDivision(span.id, item.name, item.type);
        } else if (
          item.type === "DroppableNav" ||
          item.type === "DroppableHeader" ||
          item.type === "DroppableHGroup" ||
          item.type === "DroppableFooter" ||
          item.type === "DroppableSection" ||
          item.type === "DroppableSpan" ||
          item.type === "DroppableForm" ||
          item.type === "DroppableMain" ||
          item.type === "DroppableArticle" ||
          item.type === "DroppableAside"
        ) {
          addCanvasDrop(span.id, item.name, item.type);
        } else {
          addElement(span.id, item.name, item.type);
        }
      }
    },
  });

  const constructGradientString = () => {
    const {
      backgroundGradientImage,
      gradientDirection,
      gradientShape,
      gradientPosition,
      startColor,
      endColor,
      gradientAngle,
      patternLength,
    } = span;

    switch (backgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${gradientDirection || "to right"}, ${
          startColor || "#ff7e5f"
        }, ${endColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${gradientShape || "circle"} at ${
          gradientPosition || "center"
        }, ${startColor || "#ff7e5f"}, ${endColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${gradientAngle || "45"}deg, ${
          startColor || "#606dbc"
        }, ${endColor || "#465298"} ${patternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${gradientShape || "circle"} at ${
          gradientPosition || "center"
        }, ${startColor || "#ff7e5f"}, ${endColor || "#feb47b"} ${
          patternLength || "10"
        }%)`;

      default:
        return "none";
    }
  };
  const constructHoverGradientString = () => {
    const {
      hoveredbackgroundGradientImage,
      hoveredgradientDirection,
      hoveredgradientShape,
      hoveredgradientPosition,
      hoveredstartColor,
      hoveredendColor,
      hoveredgradientAngle,
      hoveredpatternLength,
    } = span;

    switch (hoveredbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${hoveredgradientDirection || "to right"}, ${
          hoveredstartColor || "#ff7e5f"
        }, ${hoveredendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${hoveredgradientShape || "circle"} at ${
          hoveredgradientPosition || "center"
        }, ${hoveredstartColor || "#ff7e5f"}, ${hoveredendColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${hoveredgradientAngle || "45"}deg, ${
          hoveredstartColor || "#606dbc"
        }, ${hoveredendColor || "#465298"} ${hoveredpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          hoveredgradientShape || "circle"
        } at ${hoveredgradientPosition || "center"}, ${
          hoveredstartColor || "#ff7e5f"
        }, ${hoveredendColor || "#feb47b"} ${hoveredpatternLength || "10"}%)`;

      default:
        return "none";
    }
  };
  const constructFocusedGradientString = () => {
    const {
      focusedbackgroundGradientImage,
      focusedgradientDirection,
      focusedgradientShape,
      focusedgradientPosition,
      focusedstartColor,
      focusedendColor,
      focusedgradientAngle,
      focusedpatternLength,
    } = span;

    switch (focusedbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${focusedgradientDirection || "to right"}, ${
          focusedstartColor || "#ff7e5f"
        }, ${focusedendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${focusedgradientShape || "circle"} at ${
          focusedgradientPosition || "center"
        }, ${focusedstartColor || "#ff7e5f"}, ${focusedendColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${focusedgradientAngle || "45"}deg, ${
          focusedstartColor || "#606dbc"
        }, ${focusedendColor || "#465298"} ${focusedpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          focusedgradientShape || "circle"
        } at ${focusedgradientPosition || "center"}, ${
          focusedstartColor || "#ff7e5f"
        }, ${focusedendColor || "#feb47b"} ${focusedpatternLength || "10"}%)`;

      default:
        return "none";
    }
  };
  const constructActivatedGradientString = () => {
    const {
      activatedbackgroundGradientImage,
      activatedgradientDirection,
      activatedgradientShape,
      activatedgradientPosition,
      activatedstartColor,
      activatedendColor,
      activatedgradientAngle,
      activatedpatternLength,
    } = span;

    switch (activatedbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${activatedgradientDirection || "to right"}, ${
          activatedstartColor || "#ff7e5f"
        }, ${activatedendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${activatedgradientShape || "circle"} at ${
          activatedgradientPosition || "center"
        }, ${activatedstartColor || "#ff7e5f"}, ${
          activatedendColor || "#feb47b"
        })`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${
          activatedgradientAngle || "45"
        }deg, ${activatedstartColor || "#606dbc"}, ${
          activatedendColor || "#465298"
        } ${activatedpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          activatedgradientShape || "circle"
        } at ${activatedgradientPosition || "center"}, ${
          activatedstartColor || "#ff7e5f"
        }, ${activatedendColor || "#feb47b"} ${
          activatedpatternLength || "10"
        }%)`;

      default:
        return "none";
    }
  };
  const generateKeyframes = () => {
    if (!span.keyframes || span.keyframes.length === 0) return null;

    return span.keyframes.map((kf) => {
      const properties = {};
      let transform = "";

      Object.entries(kf.properties).forEach(([key, value]) => {
        // Remove 'KEY' prefix if present
        let processedKey = key.startsWith("KEY") ? key.slice(3) : key;

        // Handle transform properties
        if (
          processedKey === "scale" ||
          processedKey === "translateX" ||
          processedKey === "translateY" ||
          processedKey === "rotate" ||
          processedKey === "skewX" ||
          processedKey === "skewY"
        ) {
          if (value) {
            switch (processedKey) {
              case "scale":
                transform += `scale(${value}) `;
                break;
              case "translateX":
                transform += `translateX(${value}) `;
                break;
              case "translateY":
                transform += `translateY(${value}) `;
                break;
              case "rotate":
                transform += `rotate(${value}) `;
                break;
              case "skewX":
                transform += `skewX(${value}) `;
                break;
              case "skewY":
                transform += `skewY(${value}) `;
                break;
              default:
                break;
            }
          }
        } else {
          // Convert camelCase to kebab-case for other CSS properties
          properties[processedKey] = value;
        }
      });

      // Add transform property if it was built
      if (transform) {
        properties["transform"] = transform.trim();
      }

      return {
        offset: kf.position / 100,
        ...properties,
      };
    });
  };

  useEffect(() => {
    if (spanRef.current && span.keyframes && span.keyframes.length > 0) {
      const keyframes = generateKeyframes();
      const animation = spanRef.current.animate(keyframes, {
        duration: parseFloat(span.animationDuration) * 1000 || 1000,
        delay: parseFloat(span.animationDelay) * 1000 || 0,
        iterations:
          span.animationIterationCount === "infinite"
            ? Infinity
            : parseFloat(span.animationIterationCount) || 1,
        direction: span.animationDirection || "normal",
        fill: span.animationFillMode || "none",
        easing: span.animationTimingFunction || "linear",
      });

      return () => animation.cancel();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    span.keyframes,
    span.animationDuration,
    span.animationDelay,
    span.animationIterationCount,
    span.animationDirection,
    span.animationFillMode,
    span.animationTimingFunction,
  ]);

  useEffect(() => {
    const fetchBackgroundImage = async () => {
      if (span.backgroundImage && span.backgroundImage.startsWith("./")) {
        const imageName = span.backgroundImage.replace("./", "");
        const file = files.find((f) => f.name === imageName);
        if (file && file.data) {
          setBackgroundImageUrl(file.data);
        } else {
          console.error("Image not found in files:", imageName);
        }
      } else {
        setBackgroundImageUrl(span.backgroundImage);
      }
    };

    fetchBackgroundImage();
  }, [span.backgroundImage, files]);


  const focusedStyles =
    isSpanFocused && span.pseudoClass === "focus"
      ? {
          width: span.focusedwidth || span.width || "100%",
          height: span.focusedheight || span.height || "auto",

          padding: span.focusedpadding || span.padding || "8px",
          paddingTop: span.focusedpaddingTop || span.focusedpadding || "8px",
          paddingRight: span.focusedpaddingRight || span.focusedpadding || "8px",
          paddingBottom:
            span.focusedpaddingBottom || span.focusedpadding || "8px",
          paddingLeft: span.focusedpaddingLeft || span.focusedpadding || "8px",
          margin: span.focusedmargin || span.margin || "0px",
          marginTop: span.focusedmarginTop || span.focusedmargin || "0px",
          marginRight: span.focusedmarginRight || span.focusedmargin || "0px",
          marginBottom: span.focusedmarginBottom || span.focusedmargin || "0px",
          marginLeft: span.focusedmarginLeft || span.focusedmargin || "0px",

          borderTop:
            span.focusedborderTop ||
            span.focusedborder ||
            span.border ||
            "1px solid black",
          borderRight:
            span.focusedborderRight ||
            span.focusedborder ||
            span.border ||
            "1px solid black",
          borderBottom:
            span.focusedborderBottom ||
            span.focusedborder ||
            span.border ||
            "1px solid black",
          borderLeft:
            span.focusedborderLeft ||
            span.focusedborder ||
            span.border ||
            "1px solid black",
          borderSapcing: span.focusedborderSpacing || span.borderSpacing || "0px",
          borderCollapse:
            span.focusedborderCollapse || span.borderCollapse || "0px",
          borderRadius: span.focusedborderRadius || span.borderRadius || "0",
          outline: span.focusedoutline || span.outline || "none",

          position: span.focusedposition || span.position || "relative",
          top: span.focusedtop || span.top || "auto",
          right: span.focusedright || span.right || "auto",
          bottom: span.focusedbottom || span.bottom || "auto",
          left: span.focusedleft || span.left || "auto",
          zIndex: span.focusedzIndex || span.zIndex || "auto",
          boxShadow: span.focusedboxShadow || span.boxShadow || "none",
          opacity: span.focusedOpacity || span.opacity || 1,
          display: span.focuseddisplay || span.display || "block",
          flexDirection: span.focusedflexDirection || span.flexDirection || "column",
          flexWrap: span.focusedflexWrap || "nowrap",
          order: span.focusedorder || "0",
          flexGrow: span.focusedflexGrow || "0",
          flexShrink: span.focusedflexShrink || "1",
          flexBasis: span.focusedflexBasis || "auto",

          gridTemplateColumns: span.focusedgridTemplateColumns || "none",
          gridTemplateRows: span.focusedgridTemplateRows || "none",
          gridArea: span.focusedgridArea || "auto",
          gridAutoFlow: span.focusedgridAutoFlow || "row",
          gridAutoColumns: span.focusedgridAutoColumns || "auto",
          gridAutoRows: span.focusedgridAutoRows || "auto",
          columnGap: span.focusedcolumnGap || "0",
          rowGap: span.focusedrowGap || "0",

          justifyContent: span.focusedjustifyContent || "flex-start",
          alignItems: span.focusedalignItems || "stretch",
          alignContent: span.focusedalignContent || "stretch",
          alignSelf: span.focusedalignSelf || "auto",
          // placeContent: span.focusedplaceContent || "normal",
          // placeItems: span.focusedplaceItems || "normal",
          justifyItems: span.focusedjustifyItems || "stretch",
          justifySelf: span.focusedjustifySelf || "auto",

          gap: span.focusedgap || "0",
          visibility: span.focusedvisibility || "visible",

          color: span.focusedcolor || span.color || "#000000",
          backgroundColor:
            span.focusedbackgroundColor || span.backgroundColor || "#ffffff",
          backgroundImage: (() => {
            if (span.focusedbackgroundImage) {
              if (span.focusedbackgroundImage.startsWith("./")) {
                const imageName = span.focusedbackgroundImage.replace(
                  "./",
                  ""
                );
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${span.focusedbackgroundImage})`;
            }
            if (span.backgroundImage) {
              if (span.backgroundImage.startsWith("./")) {
                const imageName = span.backgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${span.backgroundImage})`;
            }
            return (
              constructFocusedGradientString() ||
              constructGradientString() ||
              "none"
            );
          })(),
          backgroundPosition:
            span.focusedbackgroundPosition || span.backgroundPosition || "0% 0%",
          backgroundSize:
            span.focusedbackgroundSize || span.backgroundSize || "auto",
          backgroundRepeat:
            span.focusedbackgroundRepeat || span.backgroundRepeat || "repeat",
          backgroundAttachment:
            span.focusedbackgroundAttachment ||
            span.backgroundAttachment ||
            "scroll",

          fontFamily: span.focusedfontFamily || span.fontFamily || "inherit",
          fontSize: span.focusedfontSize || span.fontSize || "inherit",
          fontWeight: span.focusedfontWeight || span.fontWeight || "normal",
          fontStyle: span.focusedfontStyle || span.fontStyle || "normal",
          fontVariant: span.focusedfontVariant || span.fontVariant || "normal",
          lineHeight: span.focusedlineHeight || span.lineHeight || "normal",
          textShadow: span.focusedtextShadow || span.textShadow || "none",
          textAlign: span.focusedtextAlign || span.textAlign || "left",
          verticalAlign:
            span.focusedverticalAlign || span.verticalAlign || "baseline",
          textDecoration:
            span.focusedtextDecoration || span.textDecoration || "none",
          textTransform:
            span.focusedtextTransform || span.textTransform || "none",
          letterSpacing:
            span.focusedletterSpacing || span.letterSpacing || "normal",
          wordSpacing: span.focusedwordSpacing || span.wordSpacing || "normal",
          textIndent: span.focusedtextIndent || span.textIndent || "0",
          whiteSpace: span.focusedwhiteSpace || span.whiteSpace || "normal",
          textOverflow: span.focusedtextOverflow || span.textOverflow || "clip",
          direction: span.focuseddirection || span.direction || "ltr",
          unicodeBidi: span.focusedunicodeBidi || span.unicodeBidi || "normal",
          writingMode:
            span.focusedwritingMode || span.writingMode || "horizontal-tb",

          cursor: span.focusedcursor || span.cursor || "default",
          filter: span.focusedfilter || span.filter || "none",
          backdropFilter:
            span.focusedbackdropFilter || span.backdropFilter || "none",
          mixBlendMode: span.focusedmixBlendMode || span.mixBlendMode || "normal",
          aspectRatio: span.focusedaspectRatio || span.aspectRatio || "auto",

          transform: span.focusedtransform || span.transform || "none",
          transition: span.focusedtransition || span.transition || "none",
        }
      : {};

  const hoverStyles =
    isSpanHovered && span.pseudoClass === "hover"
      ? {
          width: span.hoveredwidth || span.width || "100%",
          height: span.hoveredheight || span.height || "auto",

          padding: span.hoveredpadding || span.padding || "8px",
          paddingTop: span.hoveredpaddingTop || span.hoveredpadding || "8px",
          paddingRight: span.hoveredpaddingRight || span.hoveredpadding || "8px",
          paddingBottom:
            span.hoveredpaddingBottom || span.hoveredpadding || "8px",
          paddingLeft: span.hoveredpaddingLeft || span.hoveredpadding || "8px",
          margin: span.hoveredmargin || span.margin || "0px",
          marginTop: span.hoveredmarginTop || span.hoveredmargin || "0px",
          marginRight: span.hoveredmarginRight || span.hoveredmargin || "0px",
          marginBottom: span.hoveredmarginBottom || span.hoveredmargin || "0px",
          marginLeft: span.hoveredmarginLeft || span.hoveredmargin || "0px",

          borderTop:
            span.hoveredborderTop ||
            span.hoveredborder ||
            span.border ||
            "1px solid black",
          borderRight:
            span.hoveredborderRight ||
            span.hoveredborder ||
            span.border ||
            "1px solid black",
          borderBottom:
            span.hoveredborderBottom ||
            span.hoveredborder ||
            span.border ||
            "1px solid black",
          borderLeft:
            span.hoveredborderLeft ||
            span.hoveredborder ||
            span.border ||
            "1px solid black",
          borderSapcing: span.hoveredborderSpacing || span.borderSpacing || "0px",
          borderCollapse:
            span.hoveredborderCollapse || span.borderCollapse || "0px",
          borderRadius: span.hoveredborderRadius || span.borderRadius || "0",
          outline: span.hoveredoutline || span.outline || "none",

          position: span.hoveredposition || span.position || "relative",
          top: span.hoveredtop || span.top || "auto",
          right: span.hoveredright || span.right || "auto",
          bottom: span.hoveredbottom || span.bottom || "auto",
          left: span.hoveredleft || span.left || "auto",
          zIndex: span.hoveredzIndex || span.zIndex || "auto",
          boxShadow: span.hoveredboxShadow || span.boxShadow || "none",
          opacity: span.hoveredOpacity || span.opacity || 1,
          display: span.hovereddisplay || span.display || "block",
          flexDirection: span.hoveredflexDirection || span.flexDirection || "column",
          flexWrap: span.hoveredflexWrap || "nowrap",
          order: span.hoveredorder || "0",
          flexGrow: span.hoveredflexGrow || "0",
          flexShrink: span.hoveredflexShrink || "1",
          flexBasis: span.hoveredflexBasis || "auto",

          gridTemplateColumns: span.hoveredgridTemplateColumns || "none",
          gridTemplateRows: span.hoveredgridTemplateRows || "none",
          gridArea: span.hoveredgridArea || "auto",
          gridAutoFlow: span.hoveredgridAutoFlow || "row",
          gridAutoColumns: span.hoveredgridAutoColumns || "auto",
          gridAutoRows: span.hoveredgridAutoRows || "auto",
          columnGap: span.hoveredcolumnGap || "0",
          rowGap: span.hoveredrowGap || "0",

          justifyContent: span.hoveredjustifyContent || "flex-start",
          alignItems: span.hoveredalignItems || "stretch",
          alignContent: span.hoveredalignContent || "stretch",
          alignSelf: span.hoveredalignSelf || "auto",
          // placeContent: span.hoveredplaceContent || "normal",
          // placeItems: span.hoveredplaceItems || "normal",
          justifyItems: span.hoveredjustifyItems || "stretch",
          justifySelf: span.hoveredjustifySelf || "auto",

          gap: span.hoveredgap || "0",
          visibility: span.hoveredvisibility || "visible",

          color: span.hoveredcolor || span.color || "#000000",
          backgroundColor:
            span.hoveredbackgroundColor || span.backgroundColor || "#ffffff",
          backgroundImage: (() => {
            if (span.hoveredbackgroundImage) {
              if (span.hoveredbackgroundImage.startsWith("./")) {
                const imageName = span.hoveredbackgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${span.hoveredbackgroundImage})`;
            }
            if (span.backgroundImage) {
              if (span.backgroundImage.startsWith("./")) {
                const imageName = span.backgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${span.backgroundImage})`;
            }
            return (
              constructHoverGradientString() ||
              constructGradientString() ||
              "none"
            );
          })(),
          backgroundPosition:
            span.hoveredbackgroundPosition || span.backgroundPosition || "0% 0%",
          backgroundSize:
            span.hoveredbackgroundSize || span.backgroundSize || "auto",
          backgroundRepeat:
            span.hoveredbackgroundRepeat || span.backgroundRepeat || "repeat",
          backgroundAttachment:
            span.hoveredbackgroundAttachment ||
            span.backgroundAttachment ||
            "scroll",

          fontFamily: span.hoveredfontFamily || span.fontFamily || "inherit",
          fontSize: span.hoveredfontSize || span.fontSize || "inherit",
          fontWeight: span.hoveredfontWeight || span.fontWeight || "normal",
          fontStyle: span.hoveredfontStyle || span.fontStyle || "normal",
          fontVariant: span.hoveredfontVariant || span.fontVariant || "normal",
          lineHeight: span.hoveredlineHeight || span.lineHeight || "normal",
          textShadow: span.hoveredtextShadow || span.textShadow || "none",
          textAlign: span.hoveredtextAlign || span.textAlign || "left",
          verticalAlign:
            span.hoveredverticalAlign || span.verticalAlign || "baseline",
          textDecoration:
            span.hoveredtextDecoration || span.textDecoration || "none",
          textTransform:
            span.hoveredtextTransform || span.textTransform || "none",
          letterSpacing:
            span.hoveredletterSpacing || span.letterSpacing || "normal",
          wordSpacing: span.hoveredwordSpacing || span.wordSpacing || "normal",
          textIndent: span.hoveredtextIndent || span.textIndent || "0",
          whiteSpace: span.hoveredwhiteSpace || span.whiteSpace || "normal",
          textOverflow: span.hoveredtextOverflow || span.textOverflow || "clip",
          direction: span.hovereddirection || span.direction || "ltr",
          unicodeBidi: span.hoveredunicodeBidi || span.unicodeBidi || "normal",
          writingMode:
            span.hoveredwritingMode || span.writingMode || "horizontal-tb",

          cursor: span.hoveredcursor || span.cursor || "default",
          filter: span.hoveredfilter || span.filter || "none",
          backdropFilter:
            span.hoveredbackdropFilter || span.backdropFilter || "none",
          mixBlendMode: span.hoveredmixBlendMode || span.mixBlendMode || "normal",
          aspectRatio: span.hoveredaspectRatio || span.aspectRatio || "auto",

          transform: span.hoveredtransform || span.transform || "none",
          transition: span.hoveredtransition || span.transition || "none",
        }
      : {};

  const activeStyles =
    isSpanActive && span.pseudoClass === "active"
      ? {
          width: span.activatedwidth || span.width || "100%",
          height: span.hoveredheight || span.height || "auto",

          padding: span.activatedpadding || span.padding || "8px",
          paddingTop: span.activatedpaddingTop || span.activatedpadding || "8px",
          paddingRight:
            span.activatedpaddingRight || span.activatedpadding || "8px",
          paddingBottom:
            span.activatedpaddingBottom || span.activatedpadding || "8px",
          paddingLeft:
            span.activatedpaddingLeft || span.activatedpadding || "8px",
          margin: span.activatedmargin || span.margin || "0px",
          marginTop: span.activatedmarginTop || span.activatedmargin || "0px",
          marginRight: span.activatedmarginRight || span.activatedmargin || "0px",
          marginBottom:
            span.activatedmarginBottom || span.activatedmargin || "0px",
          marginLeft: span.activatedmarginLeft || span.activatedmargin || "0px",

          borderTop:
            span.activatedborderTop ||
            span.activatedborder ||
            span.border ||
            "1px solid black",
          borderRight:
            span.activatedborderRight ||
            span.activatedborder ||
            span.border ||
            "1px solid black",
          borderBottom:
            span.activatedborderBottom ||
            span.activatedborder ||
            span.border ||
            "1px solid black",
          borderLeft:
            span.activatedborderLeft ||
            span.activatedborder ||
            span.border ||
            "1px solid black",
          borderSapcing:
            span.activatedborderSpacing || span.borderSpacing || "0px",
          borderCollapse:
            span.activatedborderCollapse || span.borderCollapse || "0px",
          borderRadius: span.activatedborderRadius || span.borderRadius || "0",
          outline: span.activatedoutline || span.outline || "none",

          position: span.activatedposition || span.position || "relative",
          top: span.activatedtop || span.top || "auto",
          right: span.activatedright || span.right || "auto",
          bottom: span.activatedbottom || span.bottom || "auto",
          left: span.activatedleft || span.left || "auto",
          zIndex: span.activatedzIndex || span.zIndex || "auto",

          boxShadow: span.activatedboxShadow || span.boxShadow || "none",
          opacity: span.activatedOpacity || span.opacity || 1,
          display: span.activateddisplay || span.display || "block",
          flexDirection: span.activatedflexDirection ||  span.flexDirection || "column",
          flexWrap: span.activatedflexWrap || "nowrap",
          order: span.activatedorder || "0",
          flexGrow: span.activatedflexGrow || "0",
          flexShrink: span.activatedflexShrink || "1",
          flexBasis: span.activatedflexBasis || "auto",

          gridTemplateColumns: span.activatedgridTemplateColumns || "none",
          gridTemplateRows: span.activatedgridTemplateRows || "none",
          gridArea: span.activatedgridArea || "auto",
          gridAutoFlow: span.activatedgridAutoFlow || "row",
          gridAutoColumns: span.activatedgridAutoColumns || "auto",
          gridAutoRows: span.activatedgridAutoRows || "auto",
          columnGap: span.activatedcolumnGap || "0",
          rowGap: span.activatedrowGap || "0",

          justifyContent: span.activatedjustifyContent || "flex-start",
          alignItems: span.activatedalignItems || "stretch",
          alignContent: span.activatedalignContent || "stretch",
          alignSelf: span.activatedalignSelf || "auto",
          // placeContent: span.activatedplaceContent || "normal",
          // placeItems: span.activatedplaceItems || "normal",
          justifyItems: span.activatedjustifyItems || "stretch",
          justifySelf: span.activatedjustifySelf || "auto",

          gap: span.activatedgap || "0",
          visibility: span.activatedvisibility || "visible",

          color: span.activatedcolor || span.color || "#000000",
          backgroundColor:
            span.activatedbackgroundColor || span.backgroundColor || "#ffffff",
          backgroundImage: (() => {
            if (span.activatedbackgroundImage) {
              if (span.activatedbackgroundImage.startsWith("./")) {
                const imageName = span.activatedbackgroundImage.replace(
                  "./",
                  ""
                );
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${span.activatedbackgroundImage})`;
            }
            if (span.backgroundImage) {
              if (span.backgroundImage.startsWith("./")) {
                const imageName = span.backgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${span.backgroundImage})`;
            }
            return (
              constructActivatedGradientString() ||
              constructGradientString() ||
              "none"
            );
          })(),
          backgroundPosition:
            span.activatedbackgroundPosition ||
            span.backgroundPosition ||
            "0% 0%",
          backgroundSize:
            span.activatedbackgroundSize || span.backgroundSize || "auto",
          backgroundRepeat:
            span.activatedbackgroundRepeat || span.backgroundRepeat || "repeat",
          backgroundAttachment:
            span.activatedbackgroundAttachment ||
            span.backgroundAttachment ||
            "scroll",

          fontFamily: span.activatedfontFamily || span.fontFamily || "inherit",
          fontSize: span.activatedfontSize || span.fontSize || "inherit",
          fontWeight: span.activatedfontWeight || span.fontWeight || "normal",
          fontStyle: span.activatedfontStyle || span.fontStyle || "normal",
          fontVariant: span.activatedfontVariant || span.fontVariant || "normal",
          lineHeight: span.activatedlineHeight || span.lineHeight || "normal",
          textShadow: span.activatedtextShadow || span.textShadow || "none",
          textAlign: span.activatedtextAlign || span.textAlign || "left",
          verticalAlign:
            span.activatedverticalAlign || span.verticalAlign || "baseline",
          textDecoration:
            span.activatedtextDecoration || span.textDecoration || "none",
          textTransform:
            span.activatedtextTransform || span.textTransform || "none",
          letterSpacing:
            span.activatedletterSpacing || span.letterSpacing || "normal",
          wordSpacing: span.activatedwordSpacing || span.wordSpacing || "normal",
          textIndent: span.activatedtextIndent || span.textIndent || "0",
          whiteSpace: span.activatedwhiteSpace || span.whiteSpace || "normal",
          textOverflow: span.activatedtextOverflow || span.textOverflow || "clip",
          direction: span.activateddirection || span.direction || "ltr",
          unicodeBidi: span.activatedunicodeBidi || span.unicodeBidi || "normal",
          writingMode:
            span.activatedwritingMode || span.writingMode || "horizontal-tb",

          cursor: span.activatedcursor || span.cursor || "default",
          filter: span.activatedfilter || span.filter || "none",
          backdropFilter:
            span.activatedbackdropFilter || span.backdropFilter || "none",
          mixBlendMode:
            span.activatedmixBlendMode || span.mixBlendMode || "normal",
          aspectRatio: span.activatedaspectRatio || span.aspectRatio || "auto",

          transform: span.activatedtransform || span.transform || "none",
          transition: span.activatedtransition || span.transition || "none",
        }
      : {};

  const spanStyle = {
    width: span.width || "100%",
    height: span.height || "auto",
    padding: span.padding || "8px",
    paddingTop: span.paddingTop || span.padding || "8px",
    paddingRight: span.paddingRight || span.padding || "8px",
    paddingBottom: span.paddingBottom || span.padding || "8px",
    paddingLeft: span.paddingLeft || span.padding || "8px",
    margin: span.margin || "0px",
    marginTop: span.marginTop || span.margin || "0px",
    marginRight: span.marginRight || span.margin || "0px",
    marginBottom: span.marginBottom || span.margin || "0px",
    marginLeft: span.marginLeft || span.margin || "0px",

    borderTop: span.borderTop || span.border || "1px solid #000000",
    borderRight: span.borderRight || span.border || "1px solid #000000",
    borderBottom: span.borderBottom || span.border || "1px solid #000000",
    borderLeft: span.borderLeft || span.border || "1px solid #000000",

    borderSapcing: span.borderSpacing || "0px",
    borderCollapse: span.borderCollapse || "0px",
    borderRadius: span.borderRadius || "0",
    boxSizing: span.boxSizing || "border-box",

    position: span.position || "relative",
    top: span.top || "auto",
    right: span.right || "auto",
    bottom: span.bottom || "auto",
    left: span.left || "auto",
    zIndex: span.zIndex || "auto",

    display: span.display || "block",
    flexDirection: span.flexDirection || "column",
    flexWrap: span.flexWrap || "nowrap",
    order: span.order || "0",
    flexGrow: span.flexGrow || "0",
    flexShrink: span.flexShrink || "1",
    flexBasis: span.flexBasis || "auto",

    gridTemplateColumns: span.gridTemplateColumns || "none",
    gridTemplateRows: span.gridTemplateRows || "none",
    gridArea: span.gridArea || "auto",
    gridAutoFlow: span.gridAutoFlow || "row",
    gridAutoColumns: span.gridAutoColumns || "auto",
    gridAutoRows: span.gridAutoRows || "auto",
    columnGap: span.columnGap || "0",
    rowGap: span.rowGap || "0",

    justifyContent: span.justifyContent || "flex-start",
    alignItems: span.alignItems || "stretch",
    alignContent: span.alignContent || "stretch",
    alignSelf: span.alignSelf || "auto",
    // placeContent: span.placeContent || "normal",
    // placeItems: span.placeItems || "normal",
    justifyItems: span.justifyItems || "stretch",
    justifySelf: span.justifySelf || "auto",

    gap: span.gap || "0",
    visibility: span.visibility || "visible",

    color: span.color || "#000000",
    backgroundImage: backgroundImageUrl
      ? `url(${backgroundImageUrl})`
      : constructGradientString(),

    backgroundPosition: span.backgroundPosition || "0% 0%",
    backgroundSize: span.backgroundSize || "auto",
    backgroundRepeat: span.backgroundRepeat || "repeat",
    backgroundAttachment: span.backgroundAttachment || "scroll",
    boxShadow: span.boxShadow || "none",
    filter: span.filter || "none",
    backdropFilter: span.backdropFilter || "none",
    mixBlendMode: span.mixBlendMode || "normal",
    aspectRatio: span.aspectRatio || "auto",

    resize: span.resize || "none",
    userSelect: span.userSelect || "auto",
    overflow: span.resize && span.resize !== "none" ? "auto" : "visible",
    overflowX: span.overflowX || "hidden",
    overflowY: span.overflowY || "hidden",

    fontSize: span.fontSize || "inherit",
    fontFamily: span.fontFamily || "inherit",
    fontWeight: span.fontWeight || "normal",
    fontStyle: span.fontStyle || "normal",
    fontVariant: span.fontVariant || "normal",
    lineHeight: span.lineHeight || "normal",
    textAlign: span.textAlign || "left",
    textDecoration: span.textDecoration || "none",
    textTransform: span.textTransform || "none",
    textShadow: span.textShadow || "none",
    verticalAlign: span.verticalAlign || "baseline",
    letterSpacing: span.letterSpacing || "normal",
    wordSpacing: span.wordSpacing || "normal",
    textIndent: span.textIndent || "0",
    whiteSpace: span.whiteSpace || "normal",
    textOverflow: span.textOverflow || "clip",
    direction: span.direction || "ltr",
    unicodeBidi: span.unicodeBidi || "normal",
    writingMode: span.writingMode || "horizontal-tb",
    cursor: span.cursor || "default",
    outline: span.outline || "none",

    backgroundColor: isHovered ? "#ADD8E6" : span.backgroundColor || "#ffffff",

    listStyleType: span.listStyleType || "disc",
    listStyleImage: span.listStyleImage ? `url(${span.listStyleImage})` : "none",
    listStylePosition: span.listStylePosition || "outside",

    transform: span.transform || "none",
    transition:
      span.transition || "transform 0.3s ease, background-color 0.3s ease",

    ...hoverStyles,
    ...focusedStyles,
    ...activeStyles,
  };

  const combinedRef = useMemo(
    () => (node) => {
      spanRef.current = node;
      drop(node);
    },
    [drop]
  );

  return (
    <header
      ref={combinedRef}
      style={spanStyle}
      onMouseEnter={() => setIsSpanHovered(true)}
      onMouseLeave={() => setIsSpanHovered(false)}
      onFocus={() => setIsSpanFocused(true)}
      onBlur={() => setIsSpanFocused(false)}
      onMouseDown={() => setIsSpanActive(true)}
      onMouseUp={() => setIsSpanActive(false)}
      tabIndex={0}
    >
      {span.children &&
        span.children.map((child) => {
          switch (child.name) {
            case "Button":
              return <ButtonComponent key={child.id} button={child} />;
            case "Image":
              return <ImageComponent key={child.id} image={child} />;
            case "Heading":
              return <HeaderComponent key={child.id} header={child} />;
            case "Paragraph":
              return <ParagraphComponent key={child.id} paragraph={child} />;
            case "Icon":
              return <IconComponent key={child.id} icon={child} />;
            case "Link":
              return <LinkComponent key={child.id} link={child} />;
            case "Checkbox":
              return <CheckboxComponent key={child.id} checkbox={child} />;
            case "Radio":
              return <RadioComponent key={child.id} radio={child} />;
            case "List":
              return <ListComponent key={child.id} list={child} />;
            case "Table":
              return <TableComponent key={child.id} table={child} />;
            case "Video":
              return <VideoComponent key={child.id} video={child} />;
            case "Text":
              return <TextInputComponent key={child.id} textInput={child} />;
            case "Range":
              return <RangeComponent key={child.id} range={child} />;
            case "Password":
              return (
                <PasswordInputComponent key={child.id} passwordInput={child} />
              );
            case "Email":
              return <EmailInputComponent key={child.id} emailInput={child} />;
            case "Number":
              return (
                <NumberInputComponent key={child.id} numberInput={child} />
              );
            case "Date":
              return <DateInputComponent key={child.id} dateInput={child} />;
            case "Color":
              return <ColorInputComponent key={child.id} colorInput={child} />;
            case "File":
              return <FileInputComponent key={child.id} fileInput={child} />;
            case "Audio":
              return <AudioComponent key={child.id} audio={child} />;
            case "DropDown":
              return <DropDownComponent key={child.id} dropdown={child} />;
            case "Output":
              return <OutputComponent key={child.id} output={child} />;
            case "Map":
              return <MapComponent key={child.id} map={child} />;
            case "Nav":
              return <Nav key={child.id} nav={child} />;
            case "Header":
              return <HeaderTag key={child.id} headertag={child} />;
            case "HGroup":
              return <Hgroup key={child.id} hgroup={child} />;
            case "Footer":
              return <Footer key={child.id} footer={child} />;
            case "Section":
              return <Section key={child.id} section={child} />;
            case "Span":
              return <Span key={child.id} span={child} />;
            case "Form":
              return <FormComponent key={child.id} form={child} />;
            case "Main":
              return <MainComponent key={child.id} main={child} />;
            case "Article":
              return <ArticleComponent key={child.id} article={child} />;
            case "Aside":
              return <AsideComponent key={child.id} aside={child} />;
            case "HorizontalRule":
              return <HRTag key={child.id} div={child} />;
            case "LineBreak":
              return <BRTag key={child.id} div={child} />;
            case "Iframe":
              return <IframeComponent key={child.id} div={child} />;
            default:
              return <Division key={child.id} div={child} />;
          }
        })}
    </header>
  );
};

export default Span;
